export default __webpack_public_path__ + "static/media/Bosta Upload Template V2.8.408971fd.xlsx";